module.exports = __webpack_public_path__ + "img/0-48.1b97638a.jpg";